import React from 'react';
import './Login.css';

function Terms() {
  return (
    <div className="login-page-bg" style={{ paddingTop: '5vh', alignItems: 'flex-start' }}>
      <div className="login-card" style={{ maxWidth: '800px', padding: '2rem' }}>
        <h1 style={{ marginBottom: '1.5rem', color: 'var(--text-primary)' }}>Terms and Conditions</h1>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '1rem' }}>
          <strong>Last updated:</strong> February 11, 2026
        </p>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>1. Acceptance of Terms</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            By accessing or using TheBrainFund, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use the platform.
          </p>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>2. User Accounts</h3>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '1.5rem', lineHeight: 1.8 }}>
            <li>You must provide accurate information when creating an account.</li>
            <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
            <li>You must be at least 18 years old to use this platform.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>3. Platform Use</h3>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '1.5rem', lineHeight: 1.8 }}>
            <li>Do not use TheBrainFund for any unlawful or prohibited purpose.</li>
            <li>Do not attempt to interfere with the operation or security of the platform.</li>
            <li>Do not submit false or misleading information.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>4. Intellectual Property</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            All content, trademarks, and intellectual property on TheBrainFund are owned by the platform or its licensors. You may not copy, modify, or distribute any content without permission.
          </p>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>5. Limitation of Liability</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            TheBrainFund is provided "as is" without warranties of any kind. We are not liable for any damages or losses resulting from your use of the platform.
          </p>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>6. Account Termination</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            We reserve the right to suspend or terminate your account at any time for violation of these terms or for any reason deemed appropriate.
          </p>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>7. Changes to Terms</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            We may update these Terms and Conditions at any time. Continued use of the platform constitutes acceptance of the new terms.
          </p>
        </section>

        <section>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>8. Contact</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            For questions about these Terms and Conditions, contact us at{' '}
            <a href="mailto:thebrainpicks@gmail.com" style={{ color: 'var(--accent-primary)' }}>
              thebrainpicks@gmail.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default Terms;